module.exports = __webpack_public_path__ + "static/media/character-change-row.a79530f0.png";